
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingBOMGrid extends Serenity.EntityGrid<SKUSplittingBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUSplittingBOM'; }
        protected getDialogType() { return SKUSplittingBOMDialog; }
        protected getIdProperty() { return SKUSplittingBOMRow.idProperty; }
        protected getInsertPermission() { return SKUSplittingBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUSplittingBOMRow.localTextPrefix; }
        protected getService() { return SKUSplittingBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}